import {Link, useNavigate} from "react-router-dom";
import {useEffect, useId, useState} from "react";
import {StringDigitsConvertToPersian, ToxicDigitsFixToEnglish} from "../../components/techaran/money";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../components/template/architecture";
import {AuthRedirectSignup, PostJSON} from "../../components/api/webservice";
import {Apis} from "../../components/api/url";
import {ShowSnackbar} from "../../components/template/snackbar";
import {GradeToString} from "../admins/students/list";
import '../../static/css/pages/login/hr-login.css';
import {SignupTempDisableModal} from "./temp-disable-modal";

export const SignupLoginScreen = () => {
    const [firstname, setFirstname] = useState('');
    const [tempDisable, setTempDisable] = useState(false);
    const [lastname, setLastname] = useState('');
    const [tell, setTell] = useState('');
    const [grade, setGrade] = useState('1');
    const [national, setNational] = useState('');
    const [serial, setSerial] = useState('');
    const [err, setErr] = useState({
        firstname: false,
        lastname: false,
        tell: false,
        grade: false,
        national: false,
        serial: false,
    });
    const ids = {
        firstname: useId(),
        lastname: useId(),
        tell: useId(),
        grade: useId(),
        national: useId(),
        serial: useId(),
    };
    const [mode, setMode] = useState('login' as 'login' | 'create');
    const checkAlreadyLoggedIn = () => {
        PostJSON(
            Apis.server + '/core/signup/status',
            {},
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    return;
                }
                navigate('/signup/status',{replace:true});
            },
            () => {
            },
            () => {},
            'signup',
        ).then(void 0);
    };
    const fetchPresignupEnabled = () => {
        PostJSON(
            Apis.server + '/core/home/pres-status',
            {},
            false,
            (d: {
                result: string,
                reason: string,
                enable: boolean,
                temp: boolean,
            }) => {
                if (d.result !== 'OK')
                    return;
                if (d.enable) {
                    checkAlreadyLoggedIn();
                    setTempDisable(d.temp);
                } else {
                    navigate('/', {replace: true});
                    ShowSnackbar(
                        'ثبت‌نام در حال حاضر غیر فعال می‌باشد.',
                        'باشه',
                        5000,
                    );
                }
            },
            () => {
            },
            () => {
            },
        ).then(void 0);
    };
    useEffect(() => {
        HideMainLoading();
        document.title = 'ورود به بخش ثبت‌نام | نهال';
        fetchPresignupEnabled();
    }, []);
    const navigate = useNavigate();
    const [tempModal, setTempModal] = useState(false);
    const tryToSignin = () => {
        let data = {
            national: ToxicDigitsFixToEnglish(national.trim()),
            serial: ToxicDigitsFixToEnglish(serial.trim()),
        };
        let errors = {
            firstname: false,
            lastname: false,
            tell: false,
            grade: false,
            national: false,
            serial: false,
        };
        let stop = false;
        if (data.national.length < 5) {
            errors.national = true;
            stop = true;
        }
        if (data.serial.length < 3) {
            errors.serial = true;
            stop = true;
        }
        const tmp = tempDisable;
        setErr(errors);
        if (stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/signup/login',
            {
                national: data.national,
                serial: data.serial,
            },
            false,
            (d: {
                result: string,
                reason: string,
                tk: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'not-found') {
                        if (tmp) {
                            setTempModal(true);
                            return;
                        }
                        setMode('create');
                        ShowSnackbar('لطفا ابتدا فرم ظاهر شده را تکمیل فرمایید.', 'باشه', 5000);
                    } else if (d.reason === 'national') {
                        setErr(v => {
                            let x = {...v};
                            x.national = true;
                            return x;
                        });
                    } else if (d.reason === 'wrong') {
                        ShowSnackbar(
                            'کدملی و یا سریال شناسنامه نادرست می‌باشد.',
                            'باشه',
                            5000,
                        );
                    }
                    return;
                }
                localStorage.setItem('signupAuth', d.tk);
                navigate('/signup/status', {replace: true});
            },
            () => {
            },
            () => {
            },
            'signup',
        ).then(void 0);
    };
    const createAccount = () => {
        let data = {
            firstname:firstname.trim(),
            lastname:lastname.trim(),
            national:ToxicDigitsFixToEnglish(national.trim()),
            tell:ToxicDigitsFixToEnglish(tell.trim()),
            grade:grade.toString(),
            serial:ToxicDigitsFixToEnglish(serial.trim()),
        };
        let errors = {
            firstname: false,
            lastname: false,
            tell: false,
            grade: false,
            national: false,
            serial: false,
        };
        let stop = false;
        if (data.national.length < 5) {
            errors.national = true;
            stop = true;
        }
        if (data.serial.length < 3) {
            errors.serial = true;
            stop = true;
        }
        if(data.firstname.length < 2){
            errors.firstname = true;
            stop = true;
        }
        if(data.lastname.length < 2){
            errors.lastname = true;
            stop = true;
        }
        if(data.tell.length !== 11 || data.tell[0] !== '0' || data.tell[1] !== '9'){
            stop = true;
            errors.tell = true;
        }
        if(data.grade === ''){
            stop = true;
            errors.grade = true;
        }
        // not allowing middle-grade
        // if(data.grade !== '1' && data.grade !== '13'){
        //     stop = true;
        // }
        setErr(errors);
        if (stop)
            return;
        data.tell = '+98' + data.tell.substring(1);
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/signup/create',
            data,
            false,
            (d: {
                result: string,
                reason: string,
                tk:string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'national') {
                        setErr(v => {
                            let x = {...v};
                            x.national = true;
                            return x;
                        });
                    } else if (d.reason === 'wrong') {
                        ShowSnackbar(
                            'کدملی و یا سریال شناسنامه نادرست می‌باشد.',
                            'باشه',
                            5000,
                        );
                    }
                    else if(d.reason === 'exists'){
                        ShowSnackbar(
                            'دانش آموز با کدملی وارد شده قبلا ثبت‌نام کرده است.',
                            'باشه',
                            5000,
                        );
                        setMode('login');
                    }
                    return;
                }
                localStorage.setItem('signupAuth', d.tk);
                navigate('/signup/status', {replace: true});
            },
            () => {
            },
            ()=>{},
        ).then(void 0);
    };
    return (
        <>
            <div className="container" data-aos={"zoom-in-up"} data-aos-duration={1000}>
                <div className="row justify-content-center">
                    <div className={mode === 'login' ? 'col-lg-5' : 'col-lg-8'}>
                        <div className="login-card" style={{boxShadow:'0 0 0 0'}}>
                            <>
                                <div className="hr-login-logo">
                                    <Link to={"/"}>
                                        <i style={{backgroundImage: `url(/logo.png)`}}/>
                                    </Link>
                                    <b>مدرسه هوشمند نهال</b>
                                    <span>ورود به بخش ثبت‌نام</span>
                                </div>
                                {
                                    mode === 'login' ?
                                        <>
                                            <label htmlFor={ids.national} data-necessary="yes">کدملی:</label>
                                            <input type="text"
                                                   id={ids.national}
                                                   className={"form-control" + (err.national ? ' is-invalid' : '')}
                                                   value={national}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setNational(StringDigitsConvertToPersian(t));
                                                       setErr(v => {
                                                           let x = {...v};
                                                           x.national = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div
                                                className={"invalid-feedback" + (err.national ? ' d-block' : ' d-none')}>
                                                کد ملی وارد شده صحیح نمی‌باشد.
                                            </div>
                                            <div style={{height: 20}}/>
                                            <label htmlFor={ids.serial} data-necessary="yes">سریال شناسنامه (بدون
                                                حروف):</label>
                                            <input type="text"
                                                   id={ids.serial}
                                                   className={"form-control" + (err.serial ? ' is-invalid' : '')}
                                                   value={serial}
                                                   onChange={e => {
                                                       const t = e.currentTarget.value;
                                                       setSerial(StringDigitsConvertToPersian(t));
                                                       setErr(v => {
                                                           let x = {...v};
                                                           x.serial = false;
                                                           return x;
                                                       });
                                                   }}
                                            />
                                            <div className={"invalid-feedback" + (err.serial ? ' d-block' : ' d-none')}>
                                                سریال شناسنامه صحیح نمی‌باشد.
                                            </div>
                                            {/*<div style={{height: 20}}/>*/}
                                            <div className="hr-login-cta">
                                                <div/>
                                                <button className="btn-pay" onClick={tryToSignin}>
                                                    <b>ادامه</b>
                                                </button>
                                            </div>
                                        </> :
                                        <>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <label htmlFor={ids.firstname} data-necessary="yes">نام:</label>
                                                    <input type="text"
                                                           id={ids.firstname}
                                                           className={"form-control" + (err.firstname ? ' is-invalid' : '')}
                                                           value={firstname}
                                                           onChange={e => {
                                                               const t = e.currentTarget.value;
                                                               setFirstname(t);
                                                               setErr(v => {
                                                                   let x = {...v};
                                                                   x.firstname = false;
                                                                   return x;
                                                               });
                                                           }}
                                                    />
                                                    <div
                                                        className={"invalid-feedback" + (err.firstname ? ' d-block' : ' d-none')}>
                                                        لطفا حداقل ۲ کاراکتر وارد نمایید.
                                                    </div>
                                                    <div style={{height: 20}}/>
                                                    <label htmlFor={ids.lastname} data-necessary="yes">نام
                                                        خانوادگی:</label>
                                                    <input type="text"
                                                           id={ids.lastname}
                                                           className={"form-control" + (err.lastname ? ' is-invalid' : '')}
                                                           value={lastname}
                                                           onChange={e => {
                                                               const t = e.currentTarget.value;
                                                               setLastname(t);
                                                               setErr(v => {
                                                                   let x = {...v};
                                                                   x.lastname = false;
                                                                   return x;
                                                               });
                                                           }}
                                                    />
                                                    <div
                                                        className={"invalid-feedback" + (err.lastname ? ' d-block' : ' d-none')}>
                                                        لطفا حداقل ۲ کاراکتر وارد نمایید.
                                                    </div>
                                                    <div style={{height: 20}}/>
                                                    <label htmlFor={ids.national} data-necessary="yes">کدملی:</label>
                                                    <input type="text"
                                                           id={ids.national}
                                                           className={"form-control" + (err.national ? ' is-invalid' : '')}
                                                           value={national}
                                                           onChange={e => {
                                                               const t = e.currentTarget.value;
                                                               setNational(StringDigitsConvertToPersian(t));
                                                               setErr(v => {
                                                                   let x = {...v};
                                                                   x.national = false;
                                                                   return x;
                                                               });
                                                           }}
                                                    />
                                                    <div
                                                        className={"invalid-feedback" + (err.national ? ' d-block' : ' d-none')}>
                                                        کد ملی وارد شده صحیح نمی‌باشد.
                                                    </div>
                                                    <div style={{height: 20}}/>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label htmlFor={ids.tell} data-necessary="yes">تلفن همراه یکی از
                                                        والدین:</label>
                                                    <input type="text"
                                                           id={ids.tell}
                                                           className={"form-control" + (err.tell ? ' is-invalid' : '')}
                                                           value={tell}
                                                           onChange={e => {
                                                               const t = e.currentTarget.value;
                                                               setTell(StringDigitsConvertToPersian(t));
                                                               setErr(v => {
                                                                   let x = {...v};
                                                                   x.tell = false;
                                                                   return x;
                                                               });
                                                           }}
                                                    />
                                                    <div
                                                        className={"invalid-feedback" + (err.tell ? ' d-block' : ' d-none')}>
                                                        لطفا شماره تلفن را بصورت ۱۱ رقمی با صفر اول وارد نمایید.
                                                    </div>
                                                    <div style={{height: 20}}/>
                                                    <label htmlFor={ids.grade}>پایه تحصیلی:</label>
                                                    <select id={ids.grade}
                                                            value={grade}
                                                            onChange={e => {
                                                                const t = e.currentTarget.value;
                                                                setGrade(t);
                                                                setErr(v => {
                                                                    let x = {...v};
                                                                    x.grade = false;
                                                                    return x;
                                                                });
                                                            }}
                                                            className={"form-control" + (err.grade ? ' is-invalid' : '')}
                                                            // className={"form-control" + (err.grade || (grade !== '' && grade !== '1' && grade !== '13') ? ' is-invalid' : '')}
                                                    >
                                                        <option value="">انتخاب کنید...</option>
                                                        {[1, 2, 3, 4, 5, 6, 13].map((g, i) =>
                                                            <option value={g.toString()}
                                                                    key={"J38SSjXX_" + i}>{GradeToString(g)}</option>
                                                        )}
                                                    </select>
                                                    <div
                                                        className={"invalid-feedback" + (err.tell ? ' d-block' : ' d-none')}>لطفا یک پایه را انتخاب نمایید.</div>
                                                    {/*<div*/}
                                                    {/*    className={"invalid-feedback" + (grade !== '1' && grade !== '13' && grade !== '' ? ' d-block' : ' d-none')}>*/}
                                                    {/*    در حال حاضر، ثبت‌نام میان پایه‌ای بصورت آنلاین امکان پذیر*/}
                                                    {/*    نمی‌باشد. می‌توانید برای اطلاع بیشتر با آموزشگاه تماس بگیرید.*/}
                                                    {/*</div>*/}
                                                    <div style={{height: 20}}/>
                                                    <label htmlFor={ids.serial} data-necessary="yes">سریال شناسنامه
                                                        (بدون
                                                        حروف):</label>
                                                    <input type="text"
                                                           id={ids.serial}
                                                           className={"form-control" + (err.serial ? ' is-invalid' : '')}
                                                           value={serial}
                                                           onChange={e => {
                                                               const t = e.currentTarget.value;
                                                               setSerial(StringDigitsConvertToPersian(t));
                                                               setErr(v => {
                                                                   let x = {...v};
                                                                   x.serial = false;
                                                                   return x;
                                                               });
                                                           }}
                                                    />
                                                    <div
                                                        className={"invalid-feedback" + (err.serial ? ' d-block' : ' d-none')}>
                                                        سریال شناسنامه صحیح نمی‌باشد.
                                                    </div>
                                                    <div style={{height: 20}}/>
                                                </div>
                                            </div>
                                            <div className="hr-login-cta" style={{marginTop: 0}}>
                                                <button className="cancel-button" onClick={() => {
                                                    setMode('login');
                                                    setErr({
                                                        tell: false,
                                                        grade: false,
                                                        lastname: false,
                                                        serial: false,
                                                        national: false,
                                                        firstname: false,
                                                    });
                                                }}>
                                                    <b>بازگشت</b>
                                                </button>
                                                <button className="btn-pay" onClick={createAccount}>
                                                    <b>ادامه</b>
                                                </button>
                                            </div>
                                        </>
                                }
                            </>
                            <hr/>
                            <div className="hr-login-legal">
                                <Link to="/">وبسایت مدرسه</Link>
                                <i/>
                                <Link to={"/signup"}>درباره ثبت‌نام</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        {/*<div className="hr-login-copyright">سامانه جامع مدرسه</div>*/}
                    </div>
                </div>
            </div>
            <SignupTempDisableModal
                active={tempModal}
                closeHandler={() => setTempModal(false)}
            />
        </>
    );
};